<div class="relative cursor-pointer" (click)="copyToClipboard()">
  <div>
    <input
      class="copy-text__input !text-base-500 base-input-text text-overflowing w-full cursor-pointer !py-[0] !pl-[15px] !pr-[53px]"
      value="{{ text() }}"
      [attr.data-testid]="testId()"
      readonly
    />
  </div>

  <div
    class="border-base-600 absolute right-[15px] top-[14px] flex h-[32px] w-[32px] items-center justify-center rounded-full border"
  >
    @if (!isCopied()) {
      <svg class="fill-base-500 h-[16px] w-[16px] p-[1px]">
        <use xlink:href="#16px_copy"></use>
      </svg>
    } @else {
      <svg class="w-[15px] fill-green-500">
        <use xlink:href="#confirm"></use>
      </svg>
    }
  </div>
</div>
